import { fromJS } from 'immutable';
import type { AnyAction } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { INIT, INIT_FAILED, INIT_SUCCESS, SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAILED } from './types';

export type AutoSourcingPageState = TypedMap<{
  loading: boolean;
  submitting: boolean;
}>;

export const initialState: AutoSourcingPageState = fromJS({
  loading: true,
  submitting: false,
});

export default (state = initialState, action: AnyAction): AutoSourcingPageState => {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.set('loading', false);

    case SUBMIT:
      return state.set('submitting', true);

    case SUBMIT_SUCCESS:
      return state.set('submitting', false);

    case SUBMIT_FAILED:
      return state.set('submitting', false);

    default:
      return state;
  }
};
